<template>
  <v-row id="search-trading-category-hierarchy" class="my-6" no-gutters>
    <v-col cols="9">
      <v-autocomplete
        attach
        clearable
        hide-details="auto"
        hide-no-data
        outlined
        v-model="selectedHierarchy"
        :dense="dense"
        :disabled="viewModeOnly"
        label="Type Options to Search & Select Hierarchy *"
        :loading="fetchingHierarchy"
        :items="hierarchyList"
        v-model:search-input="userInput"
        @change="setHierarchy(selectedHierarchy)"
        @click:clear="clearHierarchy"
        :rules="[(value) => (newProduct ? fieldRequired(value) : true)]"
      ></v-autocomplete>
    </v-col>
    <v-col cols="3" class="pl-sm-2">
      <v-btn
        rounded
        class="p-btn"
        color="primary"
        :disabled="viewModeOnly"
        :class="{ 'p-btn-dense': dense }"
        :loading="downloadingHierarchyExcel"
        @click="downloadCategoriesHierarchyExcel()"
      >
        <v-icon class="mr-1">mdi-file-pdf-box</v-icon>
        {{ exportAllLabel }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment-timezone'
import FieldValidators from '@/utils/FieldValidators'
import { mapActions, mapState } from 'vuex'
import {
  downloadCategoriesHierarchyExcel,
  fetchCategoriesHierarchy
} from '@/services/products'

export default {
  props: {
    dense: {
      type: Boolean,
      default: false
    },
    exportAllLabel: {
      type: String,
      default: 'Export All'
    },
    viewModeOnly: {
      type: Boolean,
      default: true
    },
    newProduct: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    downloadingHierarchyExcel: false,
    fetchingHierarchy: false,
    hierarchyList: [],
    selectedHierarchy: undefined,
    userInput: undefined,
    ...FieldValidators
  }),

  computed: {
    ...mapState('profile', { supplierName: (state) => state.info.name }),

    currentDateTimeForFileName() {
      return moment().format('YYYYMMDD_HHmmss')
    },

    supplierAdjustedName() {
      return this.supplierName.replace(/\s/g, '_')
    }
  },

  methods: {
    ...mapActions('notifications', ['addNotification']),

    downloadCategoriesHierarchyExcel() {
      this.downloadingHierarchyExcel = true

      return downloadCategoriesHierarchyExcel()
        .then((response) => {
          const file = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(file)
          link.download = `${this.supplierAdjustedName}_flewidtech_categories_hierarchy_${this.currentDateTimeForFileName}.xlsx`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch(() => {
          this.addNotification({
            color: 'error',
            text: 'File could not be downloaded. Please try again...'
          })
        })
        .finally(() => {
          this.downloadingHierarchyExcel = false
        })
    },

    fetchCategoriesHierarchy() {
      this.fetchingHierarchy = true

      return fetchCategoriesHierarchy()
        .then((results) => {
          this.mapHierarchyResults(results)
        })
        .catch(() => {
          this.addNotification({
            color: 'error',
            text: 'Categories Hierarchy could not be loaded. Select Product Trading Department, Category and Sub-category manually.'
          })
        })
        .finally(() => {
          this.fetchingHierarchy = false
        })
    },

    mapHierarchyResults(results) {
      this.hierarchyList = results.map((result) => {
        return {
          ...result,
          // Added to be displayable in v-autocomplete
          text: result.qualifiedName,
          value: result.qualifiedName
        }
      })
    },

    setHierarchy(selectedHierarchy) {
      if (!selectedHierarchy) return

      const hierarchyData = this.hierarchyList.find(
        (item) => item.qualifiedName === selectedHierarchy
      )

      this.$emit('setProductHierarchy', hierarchyData)
    },

    clearHierarchy() {
      this.$emit('clearProductHierarchy')
    }
  },

  mounted() {
    this.fetchCategoriesHierarchy()
  }
}
</script>

<style lang="scss" scoped>
#search-trading-category-hierarchy {
  .p-btn {
    text-transform: none;
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    height: 56px;
    &-dense {
      height: 40px;
    }
  }
}
</style>
